import { Recycle, Gauge, Lightbulb, Bird } from 'lucide-react';

// Títulos y textos de cada servicio: src/data/translations.js (services.cards), en el mismo orden.
export const services = [
  { id: 1, icon: Recycle, color: "#2D6A4F", image: "/images/servicios/residuos.jpg" },
  { id: 2, icon: Gauge, color: "#2D6A4F", image: "/images/servicios/sostenibilidad.jpg" },
  { id: 3, icon: Lightbulb, color: "#2D6A4F", image: "/images/servicios/educacion.jpg" },
  { id: 4, icon: Bird, color: "#2D6A4F", image: "/images/servicios/interpretacion.jpg" },
];
